import {
  Csf,
  Address,
  License,
  Payslip,
  Identity,
  Passport,
  Statement,
} from '@assets/images';
import { tscope } from '@i18n/index';
import { DOCUMENT_TYPES } from '../../DocumentsCard';

export const ts = tscope('Requisition.documents.confirmationModal');

export const getDocumentTypesData = (type) => ({
  [DOCUMENT_TYPES.ID_CARD]: {
    mustHave: ts('idCard'),
    Image: Identity,
  },
  [DOCUMENT_TYPES.PASSPORT]: {
    mustHave: ts('passport'),
    Image: Passport,
  },
  [DOCUMENT_TYPES.PROOF_OF_ADDRESS]: {
    mustHave: ts('proofOfAddress'),
    Image: Address,
  },
  [DOCUMENT_TYPES.PAYSLIP]: {
    mustHave: ts('payslip'),
    Image: Payslip,
  },
  [DOCUMENT_TYPES.BANK_STATEMENT]: {
    mustHave: ts('bankStatement'),
    Image: Statement,
  },
  [DOCUMENT_TYPES.TAX_SITUATION]: {
    mustHave: ts('taxSituation'),
    Image: Csf,
  },
  [DOCUMENT_TYPES.OPERATING_LICENSE]: {
    mustHave: ts('operatingLicense'),
    Image: License,
  },
}[type]);
